/**
 * NOTE: 年末調整（YearEndAdjustment）route-local mock の ID 定数・ガード。
 * バックエンド API 対応後は本ファイルごと削除する。
 */
export const MOCK_YEA_OPERATION_PACKAGE_ID = 'mock-yea-operation-package';
export const MOCK_YEA_PATTERN_ID = 'mock-yea-pattern';
export const MOCK_YEA_TAG_ID = 'mock-yea-tag';

/** route-local モックの ID ガード（非 YEA は対象外） */
export const isMockYeaOperationPackageId = (id: string): boolean =>
  id === MOCK_YEA_OPERATION_PACKAGE_ID;

export const isMockYeaPatternId = (id: string): boolean =>
  id === MOCK_YEA_PATTERN_ID;

export const isMockYeaTagId = (id: string): boolean => id === MOCK_YEA_TAG_ID;

export const isMockYeaInstanceId = (id: string): boolean =>
  id.startsWith('mock-yea-inst-');

/** FORM タスク詳細 mock ID（`{instanceId}-{documentKey}-form`） */
export const isMockYeaFormTaskId = (taskId: string): boolean =>
  /^mock-yea-inst-\d+-[\w]+-form$/.test(taskId);
